module.exports = __webpack_public_path__ + "img/Consultoria-empresarial.d5ed5a05.png";